export const humanizeOwnerName = (owner: string) => {
  return owner.split(':').pop()?.split('/').pop() ?? '';
};
